import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const AuthHeader = ({ className, logoSrc, lineColor, backgroundColor, withBottomBar }) => (
  <>
    <div className={classNames(['auth-header', className])} style={{ backgroundColor }}>
      <NavLink to="/home">
        <Logo imageSrc={logoSrc} />
      </NavLink>
    </div>
    {withBottomBar && <BottomBar color={lineColor} />}
  </>
);

const BottomBar = styled.div(({ color }) => ({
  width: 'auto',
  height: '5px',
  backgroundColor: color,
}));

const Logo = styled.div(({ imageSrc }) => ({
  background: `url('${imageSrc}')`,
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  width: '100px',
  height: '49px',
}));

AuthHeader.defaultProps = {
  className: '',
  withBottomBar: true,
  lineColor: '',
};

AuthHeader.propTypes = {
  className: PropTypes.string,
  logoSrc: PropTypes.string.isRequired,
  lineColor: PropTypes.string,
  backgroundColor: PropTypes.string.isRequired,
  withBottomBar: PropTypes.bool,
};

export default AuthHeader;
